import Handlebars from "handlebars/dist/handlebars.min"

export function debounce (callback, delay) {
  let timeout

  return (...args) => {
    const context = this
    clearTimeout(timeout)

    timeout = setTimeout(() => callback.apply(context, args), delay)
  }
}

export function isEmpty(thing) {
  if (thing == null) return true

  if (Array.isArray(thing)) {
    return thing.length === 0
  }

  if (typeof thing === "object") {
    return Object.keys(thing).length === 0
  }

  return false
}

export function arraysContainSame(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;

  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  return sortedArr1.every((value, index) => value === sortedArr2[index]);
}

export function escapeExpression(string) {
  return Handlebars.Utils.escapeExpression(string)
}

export function deepEqual(a, b) {
  if (a === b) return true
  if (typeof a !== "object" || typeof b !== "object" || a == null || b == null)
    return false

  const keysA = Object.keys(a)
  const keysB = Object.keys(b)
  if (keysA.length !== keysB.length) return false

  for (const key of keysA) {
    if (!keysB.includes(key)) return false
    if (!deepEqual(a[key], b[key])) return false
  }
  return true
}

export function escapeString(string) {
  return string.replace(/"/g, '\\"')
    .replace(/\n/g, '\\n')
    .replace(/\t/g, '\\t')
    .replace(/\r/g, '\\r')
    .replace(/\f/g, '\\f')
}
